import script from "./ImprintView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImprintView.vue?vue&type=script&setup=true&lang=js"

import "./ImprintView.vue?vue&type=style&index=0&id=61e46fc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e46fc1"]])

export default __exports__